import type { ProductPickPurpose } from './types'

/** Причины открыть выбор. Новое применение («Связи товаров», РМК) добавляет значение здесь и свой текст. */
export const PICK_PURPOSE_TEXT: Readonly<Record<ProductPickPurpose, { title: string; lead: string }>> = {
  'attach-photo': {
    title: 'Выберите товар для фото',
    lead: 'Найдите в общем каталоге товар, к которому нужно прикрепить снимок. Фото уйдёт только после вашего подтверждения.',
  },
}

export function pickPurposeOf(value: string | null): ProductPickPurpose {
  return value === 'attach-photo' ? value : 'attach-photo'
}
